import React, { useEffect, useState } from 'react'
import iconFile from '../../assets/images/file.png'
import AddFileScriptArchive from './AddFileScriptArchive'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'
import { emptyOneScriptsArchive, loadOneScriptsArchive } from '../../store/Actions/ActionScriptArchive'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import userIcon from '../../assets/images/user.png'
import InnerLoader from '../../components/general/inner-loader/InnerLoader'
import EditBasicInfo from './EditBasicInfo'

function DetailsOfScriptArchive() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { oneScriptsArchive, loadingOneScriptsArchive } = useSelectorCustom()
    const { translate } = AbstructLang()
    const [openFile, setOpenFile] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isEditImage, setIsEditImage] = useState('')
    let { id } = useParams()
    useEffect(() => {
        dispatch(loadOneScriptsArchive(id))
        return (() => {
            dispatch(emptyOneScriptsArchive())
        })
    }, [])
    const [fields, setFields] = useState([{
        file_path: '',
        notes: '',
        type: '',
        descrptions: ''
    }])
    return (
        <>
            <main>
                <div className='div_table margin_main shadow_main' >
                    {
                        !loadingOneScriptsArchive ?
                            <div className='div_details_warehouse' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                                <div>
                                    <div className='d-flex' style={{ justifyContent: "space-between" }}>
                                        <h2 style={{ textTransform: "uppercase", fontSize: "20px" }} >{oneScriptsArchive.name}</h2>
                                        {
                                            isEdit ? <button className='btn_top_table' onClick={()=>setIsEdit(false)} >{translate('save')}</button>:
                                            <button className='btn_top_table' onClick={()=>setIsEdit(true)} >{translate('edit')}</button>
                                        }
                                    </div>
                                    <br></br>
                                    <div className='d-flex' >
                                        {
                                            isEditImage ? <img className='img_in_details' src={isEditImage} />:
                                            <img className='img_in_details' src={oneScriptsArchive?.thumbnail} />
                                        }
                                        
                                        {
                                            isEdit ? <EditBasicInfo setIsEditImage={setIsEditImage} oneScriptsArchive={oneScriptsArchive} translate={translate} langLocal={langLocal} /> :
                                                <div className={`${langLocal === 'ar' ? "margin_right_25" : "margin_left_25"} row_details`} style={{ width: "80%" }} >
                                                    <div>
                                                        <span className='title' >{translate('script_name')}</span>
                                                        <span>{oneScriptsArchive.name}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('script_type')}</span>
                                                        <span>{oneScriptsArchive?.creative_work_type?.type}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('episodes_count')}</span>
                                                        <span>{oneScriptsArchive?.episodes_count}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('film_duration')}</span>
                                                        <span>{oneScriptsArchive?.film_duration ? oneScriptsArchive?.film_duration : '--'}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('created_at')}</span>
                                                        <span>{moment(oneScriptsArchive?.created_at).format("YYYY-MM-DD")}</span>
                                                    </div>
                                                    <div style={{ width: '60%' }} >
                                                        <span className='title' >{translate('description')}</span>
                                                        <span>{oneScriptsArchive?.description}</span>
                                                    </div>
                                                </div>
                                        }

                                    </div>
                                    <br></br>
                                    <div>
                                        <h2 style={{ textTransform: "uppercase", fontSize: "20px" }} >{translate('production_crew')}</h2>
                                        <div className='all-production-crew' >
                                            {
                                                oneScriptsArchive?.production_crews?.map((crew) => {
                                                    return (
                                                        <div key={crew?.id} className='one-production-crew' >
                                                            <img src={userIcon} />
                                                            <span>{crew?.name} / {crew?.production_crew?.name}</span>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                    </div>
                                    <div style={{ position: "relative", marginTop: "25px" }} >
                                        {/*
                                    openFile && (
                                        <div className='more_file shadow_main1' >
                                            <AddFileScriptArchive fields={fields} setFields={setFields} />
                                            <br></br>
                                            <button className='btn_top_table' >{translate('save')}</button>
                                        </div>
                                    )
                                */}
                                        <div className='d-flex' style={{ justifyContent: "space-between" }}>
                                            <h2 style={{ textTransform: "uppercase", fontSize: "20px" }} >{translate('files')}</h2>
                                            <button className='btn_top_table' onClick={() => setOpenFile(!openFile)}  >{translate('add_file')}</button>
                                        </div>
                                        <br></br>
                                        {
                                            oneScriptsArchive.files?.map((file) => {
                                                return (
                                                    <div className='d-flex' style={{ alignItems: "center" }} >
                                                        <div className='episode_series' >
                                                            <a href={file.file_path} download>
                                                                <i className='fa fa-download download_episode' ></i>
                                                            </a>
                                                            <img src={iconFile} />
                                                            <span>{file?.name}</span>
                                                        </div>
                                                        <div className={`${langLocal === 'ar' ? "margin_right_25" : "margin_left_25"} row_details`} style={{ width: "70%" }} >
                                                            <div >
                                                                <span className='title' >{translate('type')}</span>
                                                                <span>{file.type}</span>
                                                            </div>
                                                            <div style={{ width: "70%", }} >
                                                                <span className='title' >{translate('notes')}</span>
                                                                <span>{file.notes}</span>
                                                            </div>
                                                            <div style={{ width: "70%", }} >
                                                                <span className='title' >{translate('descrptions')}</span>
                                                                <span>{file.description}</span>
                                                            </div>
                                                        </div>
                                                        <div className='plus_zone_typ' ><i className='fa fa-trash' ></i></div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                </div>
                            </div> : <InnerLoader />
                    }

                </div>
            </main>
        </>
    )
}

export default DetailsOfScriptArchive